import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CloudNotificationService } from 'src/app/services/cloud-notification.service';
import { CloudNotificationStyle } from 'src/app/models/cloud-notification-style.model';
import { SubscriptionPlan } from 'src/app/interfaces/plan.interface';
import { environment } from 'src/environments/environment';
import { Subject, takeUntil } from 'rxjs';
import Helper from 'src/app/Util/helper';
import { API_ERRORS, SUCCESS } from 'src/app/Util/constants';
import { ActivateSubscriptionRequest } from 'src/app/interfaces/services/subscription.interface';
import { CloudSubscriptionService } from 'src/app/cloud-subscription/services/cloud-subscription.service';
import { StorageKeys } from 'src/app/Util/storage-keys';
import { LocalStorageService } from 'src/app/services/localstorage.service';
import { quotationGlobalState } from 'src/app/global-state/GlobalState';
import StringHelper from 'src/app/Util/string-helper';
import { FormPersistenceService } from 'src/app/paid-subscription/services/form-persistence.service';
import { QuotationType } from 'src/app/enums/quotation.enum';
import { QuotationService } from 'src/app/paid-subscription/services/quotation.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AddTrustedTenantPathEnum } from 'src/app/enums/add-trusted-tenant.enum';
import { AddTrustedTenantPath } from 'src/app/types/az-add-trusted-tenant.type';
import { CloudVendorType } from 'src/app/paid-subscription/types/cloud-vendor.type';
import { CloudVendor } from 'src/app/enums/cloud-vendor.enum';


@Component({
  selector: 'app-view-selected-plan',
  templateUrl: './view-selected-plan.component.html',
  styleUrls: ['./view-selected-plan.component.sass']
})

export class ViewSelectedPlanComponent {

  @Input() selectedPlan: SubscriptionPlan | null = null
  @Input() subscriptionId: string
  @Input() tabIndex: number
  @Input() cloudVendor: CloudVendorType | undefined = undefined;
  @Input() period:string|null = null

  quotationPeriod: QuotationType

  @Output() updateWizardStep = new EventEmitter();

  isActivatingPlan: boolean = false;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private router: Router,
    private cloudSubscriptionService: CloudSubscriptionService,
    private notificationService: CloudNotificationService,
    private readonly localStorage: LocalStorageService,
    private readonly formService: FormPersistenceService,
    private readonly quotationService: QuotationService
  ) { }

  onPrevious() {
    this.updateWizardStep.emit(0);
  }

  onConfirmPlan() {

    this.isActivatingPlan = true;

    const activationRequest: ActivateSubscriptionRequest = {
      planId: this.selectedPlan.id,
      subscriptionId: this.subscriptionId
    }
    console.log("register-Resolving plan ID with token:", activationRequest);

    this.cloudSubscriptionService.confirmSelectedPlan(activationRequest).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (isActivated) => {
        this.notificationService.createorUpdateToastNotification(SUCCESS.plan_confirmed.title, "Subscription plan selection confirmed.", CloudNotificationStyle.success);
        this.redirect();
        this.isActivatingPlan = false;
      },

      error: (err) => {
        this.isActivatingPlan = false;
        this.notificationService.createorUpdateToastNotification(API_ERRORS.confirm_plan.title, Helper.resolveErrorMessage(err.error), CloudNotificationStyle.danger)
      }

    })

  }

  private redirect() {

    this.localStorage.setItemSessionStorage(StorageKeys.SubscriptionId, this.subscriptionId);

    quotationGlobalState.populateSubscriptionId(this.subscriptionId)

    quotationGlobalState.subscriptionId$.subscribe(sid => { })

    if (StringHelper.isPAYG(this.selectedPlan.billingTerm)) {

      // if(StringHelper.isAzure(this.cloudVendor)) {
      //   this.navigateToConnectionSetup();
      //   return;
      // }

      this.goToDashboard();

    } else {
      this.getQuotationPeriod()
    }

  }

  private redirectToDashboard() {
    this.router.navigate([environment.routes.subscription], { queryParams: { subscriptionId: this.subscriptionId } });
  }

  public isShowPrevious(){
    return this.period.toLowerCase() != "monthly";
  }

  private getQuotationPeriod() {

    this.isActivatingPlan = true

    this.quotationService.getQuotationPeriod(this.subscriptionId).pipe(takeUntil(this.unsubscribe$)).subscribe({

      next: (quotationPeriod) => {
        this.isActivatingPlan = false
        this.quotationPeriod = quotationPeriod
        this.formService.setQuotationType = quotationPeriod
        this.redirectToQuotation()
      },

      error: (error: HttpErrorResponse) => {
        this.isActivatingPlan = false
        this.notificationService.createToastNotification("get-quotation-period", 'Unable to fetch quotation period', CloudNotificationStyle.danger);
      }
    })
  }

  private redirectToQuotation() {
    if (this.quotationPeriod === QuotationType.MidYear) this.formService.isMidYear = true
    else this.formService.isMidYear = false
    this.router.navigate(['/newquotation'], { state: { subscriptionId: this.subscriptionId, isMidYear: this.quotationPeriod } })
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  goToDashboard() {
    this.router.navigate([environment.routes.subscription]);
  };
  
  private navigateToConnectionSetup() {
    const url = `/subscription/${environment.routes.connection_setup_selection}`;
    this.router.navigate([url], { queryParams: { subscriptionId: this.subscriptionId, vendor: CloudVendor.Azure }});
  };

}
